/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  Container,
  Grid,
} from 'semantic-ui-react';
import { Link } from 'react-router';
import ReactGA from 'react-ga4';
import moment from 'moment-timezone';
import { LEADV2 } from '../constants/apps';
import { TRANSLATION_FILES } from '../constants/translation';
import { restrictedModuleAccess } from '../utils/moduleAccess';
import config from '../../config';

class AppFooter extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isDeveloper: PropTypes.bool,
      isSiteplan: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isBranchLeaderSupervisor: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isAdminCommunity: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  constructor(props) {
    super(props);
    this.state = {
      leadURL: '',
    };
  }
  getLeadURL() {
    const { auth } = this.props;
    if (auth && auth.companyApps) {
      const leadv2 = auth.companyApps.find(ca => ca.appID === LEADV2);
      return leadv2.webURL;
    }
    return '';
  }
  hasLeadAccess() {
    const { auth } = this.props;
    if (auth && auth.companyApps) {
      const leadv2 = auth.companyApps.find(ca => ca.appID === LEADV2);
      if (leadv2) {
        if ((leadv2.trialEndsAt && moment(leadv2.trialEndsAt).unix() > moment().unix()) || !leadv2.trialEndsAt) {
          return true;
        }
      }
    }
    return false;
  }
  modules() {
    const restrictedAccess = restrictedModuleAccess(this.props.auth);
    return [
      {
        name: 'View All Projects',
        route: '/projects/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: true,
        isSuperAdmin: true,
        isBranchLeaderSupervisorII: false,
      },
      {
        name: 'View All Bookings',
        route: '/bookings/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: false,
        isSuperAdmin: true,
        isBranchLeaderSupervisorII: false,
      },
      {
        name: 'Manage Bookings',
        route: '/bookings/manage/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: false,
        isSiteplan: false,
        isSuperAdmin: true,
        isBranchLeaderSupervisorII: false,
      },
      this.hasLeadAccess() && {
        name: 'Lead Management',
        link: this.getLeadURL(),
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: true,
        isSuperAdmin: true,
        isBranchLeaderSupervisorII: false,
      },
      {
        name: 'Add New Project',
        route: '/projects/new/',
        enabled: true,
        isBranchLeader: false,
        isHeadquarters: true,
        isDeveloper: false,
        isSiteplan: false,
        isSuperAdmin: true,
        isBranchLeaderSupervisorII: true,
      },
      {
        name: 'Add New User',
        route: '/users/new/',
        enabled: true,
        isBranchLeader: this.props.auth.isBranchLeaderSupervisor || false,
        isHeadquarters: true,
        isDeveloper: false,
        isSiteplan: false,
        isSuperAdmin: true,
        isBranchLeaderSupervisorII: false,
      },
      {
        name: 'Manage Media',
        route: '/media/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: false,
        isSiteplan: false,
        isSuperAdmin: true,
        isBranchLeaderSupervisorII: false,
      },
      {
        name: 'Manage Payments',
        route: '/payments/',
        enabled: true,
        isBranchLeader: false,
        isDeveloper: false,
        isHeadquarters: true,
        isSuperAdmin: true,
        isBranchLeaderSupervisorII: false,
        ...restrictedAccess,
      },
      {
        name: 'Manage Bankers',
        route: '/preferred_bankers/',
        enabled: true,
        isDeveloper: true,
        isHeadquarters: true,
        isSuperAdmin: true,
        ...restrictedAccess,
      },
      {
        name: 'Manage Agencies',
        route: '/business_units/',
        enabled: true,
        isDeveloper: false,
        isHeadquarters: true,
        isSuperAdmin: true,
      },
      {
        name: 'Help',
        route: 'https://drive.google.com/drive/folders/1U6gMqLGf06-8mGZGPcKG3Ukn6-spYaQ-',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: true,
        isSuperAdmin: true,
      },
    ];
  }
  gaEvent = (e, module) => {
    ReactGA.event('BOOK_FOOTER_LINK', {
      category: 'BOOK_FOOTER_LINK',
      action: module.route || module.link,
      route: module.route || module.link,
      label: module.name,
      name: module.name,
    });
  };
  modulesFiltered = () => this.modules().filter((module) => {
    if (this.props.auth.isSuperAdmin && module.isSuperAdmin) {
      return module.isSuperAdmin;
    }
    if (this.props.auth.isHeadquarters && module.isHeadquarters) {
      return module.isHeadquarters;
    }
    if (this.props.auth.isBranchLeader && module.isBranchLeader) {
      return module.isBranchLeader;
    }
    if (this.props.auth.isDeveloper && module.isDeveloper) {
      return module.isDeveloper;
    }
    if (this.props.auth.isSiteplan && module.isSiteplan) {
      return module.isSiteplan;
    }
    if (this.props.auth.isBranchLeaderSupervisorII && module.isBranchLeaderSupervisorII) {
      return module.isBranchLeaderSupervisorII;
    }
    if (this.props.auth.isAdminBasic && module.isAdminBasic) {
      return module.isAdminBasic;
    }
    if (this.props.auth.isAdminCommunity && module.isAdminCommunity) {
      return module.isAdminCommunity;
    }
    return false;
  })
  render() {
    const { t } = this.props;
    return (
      <footer className="app-footer">
        <div className="app-quick-links-footer">
          <Container>
            <Grid>
              <Grid.Row style={{ paddingTop: '1em', paddingBottom: '0.5em', fontSize: '14px' }}>
                <Grid.Column>
                  <b>{t('Quick Links')}</b>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                  <Grid>
                    <Grid.Row className="app-link-links" columns={3}>
                      {
                        this.modulesFiltered().map((module, idx) => (
                          <Grid.Column
                            className="app-link-list"
                            name={module.name}
                            key={idx}
                            as={Link}
                            to={module.link ? '' : module.route}
                            href={module.link && module.link}
                            onClick={e => this.gaEvent(e, module)}
                            target={module.name === 'Help' || module.name === 'Lead Management' ? '_blank' : null}
                          >
                            {t(module.name)}
                          </Grid.Column>
                        ))
                      }
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
                <Grid.Column only="tablet computer" tablet={8} computer={8} />
              </Grid.Row>
            </Grid>
          </Container>
        </div>
        <div className="app-copyright-footer">
          <Container>
            <Grid>
              <Grid.Column mobile={16} tablet={11} computer={12}>
                Copyright © {moment().format('YYYY')} - TRB Ventures Sdn Bhd. All rights reserved.
              </Grid.Column>
              <Grid.Column className="app-footer-v" mobile={16} tablet={5} computer={4}>
                v{config.get('version')}{(config.get('server') === 'development' || config.get('server') === 'staging') ? ` | ${config.get('gitBranch')} (${config.get('gitHash')})` : ''}
              </Grid.Column>
            </Grid>
          </Container>
        </div>
      </footer>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens)(connect(AppFooter.mapStateToProps)(AppFooter));



// WEBPACK FOOTER //
// ./src/components/AppFooter.jsx